import { useParams } from "react-router-dom";
import { useCall } from "@/hooks/useCall/useCall";
import { RouteParams } from "../../components/Transcription/Transcription.decl";

export function usePlayerRule() {
  const { callType } = useParams<RouteParams>();
  const { call } = useCall();
  const hasSentiments = (call?.utteranceSentiments?.size ?? 0) > 0;

  return {
    // if true, show the timelineMode picker
    shouldShowTimelineModePicker: callType === "recording",
    // if true, show 3 modes
    hasSentiments,
  };
}
